import React from 'react';
import { Helmet } from 'react-helmet';
import { pageDetails } from 'routes/RouteConstants';

const SeoHelmet = () => {
  const DefaultDescription = '';

  return (
    <div>
      <Helmet>
        <title>
          {pageDetails?.title ? `${pageDetails.title} | Flexi Salary` : ''}
          {DefaultDescription}
        </title>
        <meta
          name="description"
          content={pageDetails?.description || DefaultDescription}
        />
      </Helmet>
    </div>
  );
};

export default SeoHelmet;
